module.exports = __webpack_public_path__ + "png/wheel-base.png?563451ef3e91cea4667b53eacdc8a5af";